module.exports = __webpack_public_path__ + "img/kaoqin.4f9bd472.png";